import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { albumApi } from '../../../api/album';

export const useCriticReviews = (albumId) =>
  useQuery({
    queryKey: ['criticReviews', albumId],
    queryFn: () => albumApi.getCriticReviews(albumId),
    select: (res) => res.data,
    enabled: !!albumId,
  });

export const useDeleteCriticReview = (albumId) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (reviewId) => {
      return albumApi.deleteCriticReview(reviewId);
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['criticReviews', albumId] });
    },
  });
};
